import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InputMaskModule } from 'primeng/inputmask';
import { ToastModule } from 'primeng/toast';
import { ProhibitionService } from '@max/prohibition/services/prohibition.service';
import { SharedDirectivesModule } from '@max/shared/directives/shared-directives.module';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';
import { BusinessTransactionService } from '@max/shared/services/business-transaction/business-transaction.service';
import { TitleHistoryModalModule } from '@max/titleregistration/components/shared/title/title-history/title-history-modal.module';
import { VehicleOwnershipDeInsuranceModalModule } from '@max/titleregistration/components/shared/vehicle-ownership-de-insurance/vehicle-ownership-de-insurance-modal/vehicle-ownership-de-insurance-modal.module';
import { DecalService } from '@max/titleregistration/services/decal.service';
import { InsuranceService } from '@max/titleregistration/services/insurance.service';
import { OwnershipService } from '@max/titleregistration/services/ownership.service';
import { SoldNoticeService } from '@max/titleregistration/services/sold-notice.service';
import { VehicleOwnershipDeInsuranceService } from '@max/titleregistration/services/vehicle-ownership-de-insurance.service';
import { CheckinService } from '@max/transaction/services/checkin.service';
import { VehiclePermitService } from '../../../../services/vehicle-permit.service';
import { IssueSoldNoticeModalComponent } from '../issue-sold-notice-modal/issue-sold-notice-modal.component';
import { VehicleEmissionsModalComponent } from '../vehicle-emissions-modal/vehicle-emissions-modal.component';
import { VehicleInformationSharedModule } from './vehicle-information-shared.module';
import { VehicleInformationComponent } from './vehicle-information.component';
import { VehicleInformationRoutableComponent } from './vehicle-information.routable.component';
import { WatchYourCarModalComponent } from './watch-your-car.modal.component';
import { NoteModule } from '../../../../../note/note.module';
import { HistoricalCommercialVehiclePermitModule } from '@max/commercialpermitting/components/shared/historical-commercial-vehicle-permit-number-modal/historical-commercial-vehicle-permit-number-modal.module';
import { OutOfJurisdictionRegistrationModalModule } from '@max/commercialpermitting/components/shared/out-of-jurisdiction-registration-modal/out-of-jurisdiction-registration-modal.module';
import { OutOfJurisdictionRegistrationHistoryModalModule } from '@max/commercialpermitting/components/shared/out-of-jurisdiction-registration-history-modal/out-of-jurisdiction-registration-history-modal.module';
import { MotorCarrierAccountTPAFeeSummaryModalModule } from '../../../../../irp/shared/components/motor-carrier-account-tpa-fee-summary/motor-carrier-account-tpa-fee-summary-modal.module';
import { TitleRegistrationUserService } from '../../../../../titleregistration/services/titleregistration-user.service';
import { MobileHomeLinkedSectionsComponent } from '../mobile-home/mobile-home-linked-sections/mobile-home-linked-sections.component';
import { VehicleMobileHomeService } from '../../../../services/vehicle-mobile-home.service';

@NgModule({
    declarations: [
        IssueSoldNoticeModalComponent,
        VehicleEmissionsModalComponent,
        VehicleInformationComponent,
        VehicleInformationRoutableComponent,
        WatchYourCarModalComponent,
        MobileHomeLinkedSectionsComponent
    ],
    providers: [
        BusinessTransactionService,
        CheckinService,
        DecalService,
        InsuranceService,
        OwnershipService,
        ProhibitionService,
        SoldNoticeService,
        VehicleOwnershipDeInsuranceService,
        VehiclePermitService,
        TitleRegistrationUserService,
        VehicleMobileHomeService
    ],
    imports: [
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        InputMaskModule,
        RouterModule,
        SharedDirectivesModule,
        SharedPipesModule,
        TitleHistoryModalModule,
        VehicleInformationSharedModule,
        VehicleOwnershipDeInsuranceModalModule,
        NoteModule,
        HistoricalCommercialVehiclePermitModule,
        OutOfJurisdictionRegistrationModalModule,
        OutOfJurisdictionRegistrationHistoryModalModule,
        MotorCarrierAccountTPAFeeSummaryModalModule,
        ToastModule
    ],
    exports: [
        VehicleInformationComponent,
        WatchYourCarModalComponent
    ]
})
export class VehicleInformationCoreModule {
}
